import { removeActivity, resetSelections, setActivityDate, setOpportunity, setPaymentCountDown } from "../store/MahutiReducer";
import { ClearLocalStorage, getLocalStoragKey, setLocalStorage } from "../store/mahutiLocalStorage";
import { PREFIX_PATH } from "./GlobalParams";

export const calculateCountDownSeconds = (min, newPurchase, store) => {
    let minSpred = store.lpParams.cartTimer || 5;
    let date1 = new Date();
    let date2 = new Date ( date1 );
    date2.setMinutes ( date1.getMinutes() + minSpred );
    let timeDiff = date2-date1;
    if(timeDiff < 0){
        return undefined
    }else{
        let minLeft = checkTimestemp(getLocalStoragKey('countDownTimestemp'), min);
        (!minLeft || newPurchase) && setLocalStorage('countDownTimestemp', date2)
        return minLeft ? minLeft : min ? Math.round(((timeDiff % 86400000) % 3600000) / 60000) : Math.round(timeDiff / 1000)
    }
}

export const checkTimestemp = (endTimestemp, min) => {
    let date1 = new Date();
    let date2 = new Date (endTimestemp)
    let timeDiff = date2-date1;
    if(timeDiff < 0){
        return false
    }else{
        return min ? Math.round(((timeDiff % 86400000) % 3600000) / 60000) : Math.round(timeDiff / 1000)
    }
}

export const clearAll = (dispatch) => {
    dispatch(setPaymentCountDown(undefined));
    dispatch(removeActivity('*'))
    setLocalStorage('countDownTimestemp', null)
    ClearLocalStorage()
    dispatch(setOpportunity())
    dispatch(resetSelections())
    dispatch(setActivityDate(undefined))
}

export const checkCartItems = (store, dispatch, navigate, location) => {
    if(store.selectedActivities.length > 0 && !store.opportunity?.id){
        clearAll(dispatch);
        if(location.pathname !== '/tickets_dev' && location.pathname !== '/tickets'){
            let lpPrefix = store.lpName ? '/' + store.lpName : '';
            navigate(PREFIX_PATH + lpPrefix + '/');
        }
    }
}

export const fixDateDirection = (date) => {
    if(date){
        let dateArray = date.split('-')
        if(dateArray.length === 3){
            let newDate = dateArray[2] + '/' + dateArray[1] + '/' + dateArray[0]
            return newDate
        }else{
            return date
        }
    }else{
        return date
    }
}